document.addEventListener("DOMContentLoaded", function () {
    const toggles = document.querySelectorAll(".block__faq-toggle");

    toggles.forEach(toggle => {
        toggle.addEventListener("click", function () {
            const isExpanded = this.getAttribute("aria-expanded") === "true";

            // Close all others
            toggles.forEach(btn => {
                if (btn !== this) {
                    btn.setAttribute("aria-expanded", "false");
                    btn.nextElementSibling.style.maxHeight = null;
                    btn.closest('.block__faq-content-block').classList.remove("block__faq-content-block--open");
                }
            });

            if (!isExpanded) {
                this.setAttribute("aria-expanded", "true");
                const answer = this.nextElementSibling;
                answer.style.maxHeight = answer.scrollHeight + "px";
                this.closest('.block__faq-content-block').classList.add("block__faq-content-block--open");
            } else {
                this.setAttribute("aria-expanded", "false");
                this.nextElementSibling.style.maxHeight = null;
                this.closest('.block__faq-content-block').classList.remove("block__faq-content-block--open");
            }
        });
    });

    // Set max-height for already expanded (first) item
    document.querySelectorAll('.block__faq-toggle[aria-expanded="true"]').forEach(openToggle => {
        const answer = openToggle.nextElementSibling;
        answer.style.maxHeight = answer.scrollHeight + "px";
    });
});